
import moment from 'moment'
export default date => {
    return [
        {
            name: moment(date).format('YYYY-MM'),
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Nights",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "OCC%",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "ADR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Revenue",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "RevPAR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: moment(date).add(1, 'month').format("YYYY-MM"),
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Nights",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "OCC%",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "ADR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Revenue",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "RevPAR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: moment(date).add(2, 'month').format("YYYY-MM"),
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Nights",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "OCC%",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "ADR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "Room Revenue",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        },
        {
            name: "RevPAR",
            otb: 0,
            forecast: 0,
            otbForecast: 0,
            otbForecastS: 0,
            budget: 0,
            otbBudget: 0,
            otbBudgetS: 0,
            last: 0,
            otbLast: 0,
            otbLastS: 0,
            dayPU: 0,
        }
    ].map((x, i) => ({ ...x, sort: i, code: i }))
}



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.4/data.js